export default {
  active: state => state.active
}
